import { magellanClient } from '../../../infra/axios';
import type {
  CreateVaultSearchRequestDTO,
  CreateVaultSearchResponseDTO,
  FindOneVaultSearchResponseDTO,
} from './dto';

export async function createSearch({
  question,
}: CreateVaultSearchRequestDTO): Promise<CreateVaultSearchResponseDTO> {
  const response = await magellanClient.post<CreateVaultSearchResponseDTO>(
    `/vaultSearch`,
    { question },
  );

  return response.data;
}

export async function getSearchById({
  searchId,
}: {
  searchId: number;
}): Promise<FindOneVaultSearchResponseDTO> {
  const response = await magellanClient.get<FindOneVaultSearchResponseDTO>(
    `/vaultSearch/${searchId}`,
  );

  return response.data;
}
